/**
 * ROADMAP_ITEMS — customer-facing "what we are building next", shown on the
 * plan picker in place of the add-on module grid.
 *
 * DRAFT COPY — review before this reaches customers. These are written from
 * docs/ROADMAP.md in benefit language, deliberately without dates or delivery
 * commitments: nothing here is sold, entitled, or billable, and no plan
 * feature list may reference an item until it ships.
 *
 * `plan` names the lowest tier an item is expected to land in, for context
 * only. Update CHANGELOG.md when modifying this list.
 */
export interface RoadmapItem {
  id: string;
  title: string;
  description: string;
  /** Bootstrap icon class for the card. */
  icon: string;
  /** Lowest plan the capability is expected to reach. */
  plan: string;
}

export const ROADMAP_ITEMS: readonly RoadmapItem[] = [
  {
    id: 'roadmap_multicloud',
    title: 'AWS and GCP at Azure depth',
    description:
      'AWS and GCP control checks brought up to the depth of our Azure and Microsoft 365 coverage, so every cloud you run gets the same scrutiny from one platform.',
    icon: 'bi-clouds-fill',
    plan: 'Professional',
  },
  {
    id: 'roadmap_container_k8s',
    title: 'Container and Kubernetes scanning',
    description:
      'Image vulnerability scanning, SBOM generation, pod security and RBAC misconfiguration checks across your clusters.',
    icon: 'bi-box-seam-fill',
    plan: 'Professional',
  },
  {
    id: 'roadmap_saas_posture',
    title: 'SaaS configuration scanning',
    description:
      'Posture checks for Google Workspace, GitHub and Slack — the systems that hold your data but never appear in a cloud scan.',
    icon: 'bi-grid-3x3-gap-fill',
    plan: 'Essentials',
  },
  {
    id: 'roadmap_attack_path',
    title: 'Attack path analysis',
    description:
      'Findings mapped to MITRE ATT&CK and chained into likely lateral-movement paths, so you fix the finding that actually opens the door.',
    icon: 'bi-diagram-3-fill',
    plan: 'Professional',
  },
  {
    id: 'roadmap_edr_xdr',
    title: 'EDR and XDR integrations',
    description:
      'Connectors for CrowdStrike, Microsoft Defender and SentinelOne, normalising endpoint detections into the same findings pipeline.',
    icon: 'bi-shield-lock-fill',
    plan: 'Enterprise',
  },
  {
    id: 'roadmap_auto_remediation',
    title: 'Guided auto-remediation',
    description:
      'Approve a generated fix and let the platform apply it, with a full change record kept as audit evidence.',
    icon: 'bi-magic',
    plan: 'Professional',
  },
];
